import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserProfileDetailsSelector } from '@store/selectors/UserProfileSelector';
import { useChatBuilderConfig } from '@components/Chat/hooks/useChatBuilderConfig/useChatBuilderConfig';
import {
	getChatAuthToken,
	GetChatAuthTokenResponse,
} from '@data/liveChat/actionCreators/LiveChatActionCreators';
import { AxiosResponse } from 'axios';
import { useIsChatEnabled } from '@components/Chat/hooks/useIsChatEnabled/useIsChatEnabled';

export const useGetChatAuthToken = () => {
	const dispatch = useDispatch();
	const { userId } = useSelector(UserProfileDetailsSelector);
	const [authToken, setAuthToken] = React.useState<string | null>(null);
	const hasChatConfig = useChatBuilderConfig();
	const hasRequestedToken = React.useRef(false);
	const { isChatEnabled } = useIsChatEnabled();

	React.useEffect(() => {
		if (!hasChatConfig || !userId || hasRequestedToken.current || !isChatEnabled) {
			return;
		}

		hasRequestedToken.current = true;
		const onSuccess = (response: AxiosResponse<GetChatAuthTokenResponse>) => {
			setAuthToken(response.data.authToken);
		};

		dispatch(getChatAuthToken(userId, { onSuccess }));
	}, [dispatch, hasChatConfig, isChatEnabled, userId]);

	return { authToken };
};
